import InvoiceIcon from '@mui/icons-material/LibraryBooks';

import InvoiceList from './InvoiceList';

export default {
    list: InvoiceList,
    icon: InvoiceIcon,
};
